import prismjs, { type Token, type Grammar } from "prismjs";
import "./prism-languages";
import { For, type JSX, Show, createEffect, createRenderEffect, createSignal, on } from "solid-js";
import type { CodeBlockASTNode } from "../toastmark/ast";

export const HighlightedCodeBlock = (props: { node: CodeBlockASTNode; class?: string; codeClass?: string }) => {
  const [stream, setStream] = createSignal<(Token | string)[]>([]);

  const renderToken = (token: Token | string): JSX.Element => {
    if (typeof token === "string") {
      return <>{token}</>;
    }

    // Token object - apply CSS classes
    const className = token.type ? `token ${token.type}` : "token";

    // Handle different content types
    if (typeof token.content === "string") {
      return <span class={className}>{token.content}</span>;
    }

    if (Array.isArray(token.content)) {
      return <span class={className}>{token.content.map(renderToken)}</span>;
    }

    // Nested token
    return <span class={className}>{renderToken(token.content)}</span>;
  };

  createRenderEffect(
    on(
      () => props.node.literal,
      () => {
        const grammar = prismjs.languages[props.node.info || ""] || (prismjs.languages.plaintext as Grammar);
        const tokens = prismjs.tokenize(props.node.literal || "", grammar);
        setStream(tokens);
      },
    ),
  );

  return (
    <pre class={props.class}>
      <code class={`language-${props.node.info || ""} ${props.codeClass || ""}`}>
        <For each={stream()}>{(token) => renderToken(token)}</For>
      </code>
    </pre>
  );
};
